import { useEffect, useRef } from 'preact/hooks';
import { apiClient } from '@/api/client';
import { useToast } from '@/hooks/useToast';
import { useAuth } from '@/auth/useAuth';
/**
 * GlobalErrorHandler sets up the API client to automatically handle:
 * - 422 (Business Rule) errors: displays validation error toasts
 * - 403 (Forbidden) errors: refreshes user profile and shows permission warning
 */
export function GlobalErrorHandler() {
    const { showValidationErrors, showWarning } = useToast();
    const { refreshUserProfile } = useAuth();
    const lastForbiddenRefresh = useRef(0);
    useEffect(() => {
        // Set up the global validation error handler for 422 responses
        apiClient.setValidationErrorHandler((errors) => {
            showValidationErrors(errors);
        });
    }, [showValidationErrors]);
    useEffect(() => {
        // Set up the global forbidden handler for 403 responses
        apiClient.setForbiddenHandler(() => {
            const now = Date.now();
            // Debounce: skip if we refreshed within the last 5 seconds
            if (now - lastForbiddenRefresh.current < 5000)
                return;
            lastForbiddenRefresh.current = now;
            showWarning('Permission Denied', 'Your permissions have been updated. The page will reflect your current access.');
            refreshUserProfile();
        });
    }, [showWarning, refreshUserProfile]);
    // This component doesn't render anything
    return null;
}
